import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { BtnLink } from '@mi-front/ui';
import {
  CheckCircle as CheckCircleIcon,
  Close as CloseIcon,
  Info as InfoIcon,
  Replay as RestartIcon,
} from '@mui/icons-material';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Fragment } from '../../../../../../fragments/types';
import { useStreamSettingsStore } from '../../../stores/stream-screen-settings.store';
import { StreamMode } from '../../../types';
import { useFragmentEditorStore } from '../../stores/useFragmentEditorStore';

interface Props {
  fragment: Fragment;
}

export function FragmentCreatedPanel(p: Props) {
  const station = useActiveStation();
  const updateSettings = useStreamSettingsStore((state) => state.updateSettings);
  const initializeEditor = useFragmentEditorStore((state) => state.initializeEditor);
  const closeEditor = useFragmentEditorStore((state) => state.closeEditor);

  const createNew = () => {
    initializeEditor(station.id);
  };

  const handleCloseEditor = () => {
    closeEditor();
    // Change screen mode to DEFAULT
    updateSettings({
      mode: StreamMode.DEFAULT,
    });
  };

  return (
    <div className="bg-gray-100 p-5 rounded d-flex flex-column align-items-center justify-content-center">
      <h5 className="mb-3">
        <CheckCircleIcon />{' '}
        <FormattedMessage
          id="jointFragments.overview.message"
          defaultMessage="Fragmento guardado"
        />
      </h5>
      <div className="d-flex justify-content-center" style={{ gap: '8px' }}>
        <BtnLink to={`/fragments/${p.fragment.id}`} size={'sm'} icon={<InfoIcon />}>
          <FormattedMessage
            id="jointFragments.overview.detailLink"
            defaultMessage="Ver detalle del fragmento"
          />
        </BtnLink>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          startIcon={<RestartIcon />}
          onClick={createNew}
        >
          <FormattedMessage
            id="jointFragments.overview.createNew"
            defaultMessage="Crear nuevo fragmento"
          />
        </Button>
        <Button
          component={Link}
          to={`/fragments/${p.fragment.id}`}
          size="small"
          variant="outlined"
          color="secondary"
          startIcon={<CloseIcon />}
          onClick={handleCloseEditor}
        >
          <FormattedMessage
            id="jointFragments.overview.closeEditor"
            defaultMessage="Cerrar editor"
          />
        </Button>
      </div>
    </div>
  );
}
